import React from 'react';
import ReactDOM from 'react-dom/client'
import Feed from './Frontend/Feed';
// a11y(SMASH-1377 F1): LoadMoreButton announces 'Loaded N more posts' via
// useAnnouncer(), but the provider (which renders the aria-live regions) was
// mounted only in the builder entry — on the public feed the hook silently
// no-ops. Mount the provider around each feed root so announcements reach AT.
import { AnnouncerProvider } from './a11y/Announcer';
// a11y(SMASH-1377 F2): utility classes (.sb-button-reset / .sb-visually-hidden)
// used by the frontend feed components were only bundled into the builder's
// main.css; import the frontend-safe subset so tikTokFeed.css defines them.
import './assets/css/a11y-frontend.css';

function sbttInitializeFeed() {
    const rootEl = document.querySelectorAll(".sbtt-tiktok-feed");
    if (rootEl.length > 0) {
        rootEl.forEach((el) => {
            const feedSettings = JSON.parse(el.getAttribute('data-feed-settings'));
            const feedId = el.getAttribute('data-feed-id');
            const posts = JSON.parse(el.getAttribute('data-feed-posts'));
            const headerData = JSON.parse(el.getAttribute('data-feed-header'));
            const nextPage = el.getAttribute('data-next-page');

            const root = ReactDOM.createRoot(el);
            root.render(
                <React.StrictMode>
                    <AnnouncerProvider>
                        <Feed
                            feedSettings={feedSettings}
                            feedId={feedId}
                            posts={posts}
                            headerData={headerData}
                            nextPage={nextPage}
                        />
                    </AnnouncerProvider>
                </React.StrictMode>

            );
        });
    }
}

sbttInitializeFeed();

// Expose the function globally.
window.sbttInitializeFeed = sbttInitializeFeed;
